export default function Card({
  children,
  className = '',
  hover = true,
  ...props
}) {
  const hasBg = className.includes('bg-');
  const hasBorder = className.includes('border-');
  const hasHoverBg = className.includes('hover:bg-');

  return (
    <div
      className={`${!hasBg ? 'bg-charcoal-dark/40' : ''} rounded-2xl relative overflow-hidden transition-all duration-500 ${!hasBorder ? 'border border-dusty-rose/10' : 'border'} ${
        hover ? `${!hasHoverBg ? 'hover:bg-charcoal-dark/60' : ''} hover:border-dusty-rose/40 hover:shadow-2xl hover:-translate-y-1` : ''
      } ${className}`}
      {...props}
    >
      {/* Dashed border effect */}
      <div className="absolute inset-0 border border-dashed border-dusty-rose/20 pointer-events-none group-hover:border-dusty-rose/30 transition-colors duration-500" />
      
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}

export function CardImage({ src, alt, className = '' }) {
  return (
    <div className={`aspect-[4/3] overflow-hidden ${className}`}>
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
      />
    </div>
  );
}

export function CardContent({ children, className = '' }) {
  return (
    <div className={`p-6 text-chalk ${className}`}>
      {children}
    </div>
  );
}
